var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewReject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM10.8839 8.61612C10.3957 8.12796 9.60427 8.12796 9.11612 8.61612C8.62796 9.10427 8.62796 9.89573 9.11612 10.3839L10.7322 12L9.11612 13.6161C8.62796 14.1043 8.62796 14.8957 9.11612 15.3839C9.60427 15.872 10.3957 15.872 10.8839 15.3839L12.5 13.7678L14.1161 15.3839C14.6043 15.872 15.3957 15.872 15.8839 15.3839C16.372 14.8957 16.372 14.1043 15.8839 13.6161L14.2678 12L15.8839 10.3839C16.372 9.89573 16.372 9.10427 15.8839 8.61612C15.3957 8.12796 14.6043 8.12796 14.1161 8.61612L12.5 10.2322L10.8839 8.61612Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReject);
export default __webpack_public_path__ + "static/media/new-reject.fa8f69b6c78ef14cda4498c645fb0f6d.svg";
export { ForwardRef as ReactComponent };